import { Link } from "react-router-dom";
import { Seo } from "../lib/seo";
import { WhatWeMake } from "../components/WhatWeMake";
import { DemoShowcase } from "../components/DemoShowcase";
import { TwoProductOverview } from "../components/TwoProductOverview";
import { BankingFuture } from "../components/BankingFuture";
import { ComparisonTable } from "../components/ComparisonTable";
import { CompliancePillars } from "../components/CompliancePillars";

export const Home = () => (
  <>
    <Seo
      title="Bring your bank to AI. In weeks, not quarters."
      description="Bancony makes a bank's accounts, payments and services available to AI agents on an open standard, with the bank's controls intact, and ships a customer-ready assistant that runs inside the bank's own app."
      path="/"
    />

    <section className="home-hero" data-section="hero">
      <div className="home-hero-inner">
        <span className="section-eyebrow">AI for digital banking</span>
        <h1>
          Bring your bank to AI.{" "}
          <span className="accent">In weeks, not quarters.</span>
        </h1>
        <p className="home-hero-sub">
          Bancony makes your digital banking accessible to AI agents in a secure,
          standard way, and ships a customer-ready assistant on top. So your bank
          can launch real AI experiences without building the plumbing yourself.
        </p>
        <div className="home-hero-ctas">
          <Link to="/contact?intent=demo" className="btn btn-primary">Book a demo</Link>
          <a href="#products" className="btn btn-ghost">See what we make</a>
        </div>
        <div className="home-hero-meta">
          <span>Live in weeks</span>
          <span>Any AI agent, your bank's controls</span>
          <span>Open standard, no lock-in</span>
        </div>
      </div>
    </section>

    <WhatWeMake />
    <DemoShowcase />
    <TwoProductOverview />
    <BankingFuture />
    <ComparisonTable />
    <CompliancePillars />

    <section className="section" data-section="open-standard">
      <div className="section-inner">
        <div className="stewardship">
          <div>
            <span className="section-eyebrow">Open by design</span>
            <h2>Built on an open standard.</h2>
            <p>
              Bancony's products run on{" "}
              <a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer" className="bank2ai-link">bank2ai</a>,
              an open specification that defines how banking systems expose
              capabilities to AI agents. Bancony stewards the spec; anyone else can
              implement it.
            </p>
            <p>
              That means your bank's investment is in the standard, not in our
              proprietary glue. If you ever change vendor, your handlers, schemas, and
              contracts come with you. No rewrite.
            </p>
            <p>
              <Link to="/standard" className="btn-arrow">How the standard works</Link>
            </p>
          </div>
          <div className="stewardship-mark">
            <span className="stewardship-mark-tag">Open standard</span>
            <span className="stewardship-mark-name">bank2ai</span>
            <a
              href="https://bank2ai.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost stewardship-mark-link"
            >
              bank2ai.com →
            </a>
          </div>
        </div>
      </div>
    </section>

    <section className="section soft" data-section="reference-customers">
      <div className="section-inner">
        <span className="section-eyebrow">Reference customers</span>
        <h2 style={{ fontSize: 24 }}>Reference customers will be named with their permission.</h2>
        <p style={{ maxWidth: 640, color: "var(--ink-mute)", fontSize: 15 }}>
          The first European banks to go live on Bancony will be named publicly with
          their permission, alongside the case studies their teams help us write.
        </p>
      </div>
    </section>

    <section className="section" data-section="final-cta">
      <div className="section-inner">
        <div className="final-cta">
          <div>
            <h2>Talk to us about a pilot.</h2>
            <p>30-minute call. We'll show the runtime, the assistant, and the contract.</p>
          </div>
          <div className="final-cta-cta">
            <Link to="/contact?intent=demo" className="btn btn-primary">Book a demo</Link>
          </div>
        </div>
      </div>
    </section>
  </>
);
